import React from "react";
import { PaziaModalBlank } from "./PaziaModalBlank";

export interface PaziaDeleteModalProps {
  title: string;
  description: string;
  onConfirm: () => void;
  onCloseRequest: () => void;
  id: string;
  isOpen: boolean;
  cancelText?: string;
  confirmText?: string;
}
export const PaziaDeleteModal = ({
  title,
  description,
  onConfirm,
  onCloseRequest,
  isOpen,
  id,
  cancelText = "Anuluj",
  confirmText = "Tak, usuń",
}: PaziaDeleteModalProps) => {
  return (
    <PaziaModalBlank modalOpen={isOpen} onCloseRequest={onCloseRequest} id={id}>
      <div className="p-5 flex space-x-4">
        {/* Icon */}
        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-primary-100 dark:bg-primary-500/30">
          <svg
            className="w-4 h-4 shrink-0 fill-current text-primary-600"
            viewBox="0 0 16 16"
          >
            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
          </svg>
        </div>
        {/* Content */}
        <div>
          {/* Modal header */}
          <div className="mb-2">
            <div className="text-lg font-semibold text-slate-800 dark:text-slate-100">
              {title}
            </div>
          </div>
          {/* Modal content */}
          <div className="text-sm mb-10">
            <div className="space-y-2">
              <p>{description}</p>
            </div>
          </div>
          {/* Modal footer */}
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              className="btn-sm border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-slate-600 dark:text-slate-300"
              onClick={(e) => {
                e.stopPropagation();
                onCloseRequest();
              }}
            >
              {cancelText}
            </button>
            <button
              className="btn-sm bg-primary-500 hover:bg-primary-600 text-white"
              onClick={(e) => {
                e.stopPropagation();
                onConfirm();
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </PaziaModalBlank>
  );
};
